// extracted by mini-css-extract-plugin
module.exports = {"reportPage":"MR6S-","footerBanner":"_3-Uea"};